import { Modal, Pagination, Select, Spin, Tag, notification } from "antd";
import { Option } from "antd/es/mentions";
import requestService from "api/request";
import ListCoinDeposit from "components/ListCoinDeposit";
import { formatNumber } from "lib/helpers/format";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "store";
import { useCopyToClipboard } from "usehooks-ts";

const Withdraw = () => {
  const { user, appGlobal } = useAppSelector((state) => state.app) as any;
  const [copiedText, copy] = useCopyToClipboard();
  const [isOpenListCoin, setIsOpenListCoin] = useState(false);
  const [addressTo, setAddressTo] = useState<string>("");
  const [fromTo, setFromTo] = useState<string>("");
  const [isNetWorks, setIsNetwork] = useState(false);
  const [amount, setAmount] = useState(0);
  const [netWorkSelected, setNetworkSelected] = useState<any>();
  const [tokenSelecteds, setTokenSelectd] = useState<any>();
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [historyData, setHistory] = useState<any>([]);
  const [page, setPage] = useState<number>(1);
  const [showGuide, setShowGuide] = useState(false);
  const [showGuide1, setShowGuide1] = useState(false);
  const [showGuide2, setShowGuide2] = useState(false);
  const [openWithdrawPass, setOpenWithdrawPass] = useState(false);
  const [withdrawPassword, setWithdrawPassword] = useState("");
  const { t } = useTranslation();

  const onChangeMoneyValue = (e: any) => {
    let money_value =
      parseFloat(e.target.value.toString().replace(/,/g, "")) || 0;
    setAmount(money_value);
  };

  const [typeDeposit, setTypeDeposit] = useState("bank");
  const [region, setRegion] = useState("vi");

  const networks = [
    {
      network: "Tron(TRC20)",
      address: "TBnN897FgFUVPnyMmZNjPKCojJtLqGebBB",
      imgQr: "/img/qr-trc20.png",
    },
    {
      network: "BNB Smart Chain (BEP20)",
      address: "0xFa7f5aA04CE05F0D72c49Af901F7F331CAB794bB",
      imgQr: "/img/qr-bep20.png",
    },
  ];

  function getCurrencyName(region: string) {
    switch (region) {
      case "vi":
        return "Vnd";
      case "thai":
        return "Baht";
      case "cn":
        return "CNY";
      case "cam":
        return "Riel";
      default:
        return "Currency not found";
    }
  }
  const onChangePage = async (page: number) => {
    getTransactions(page);
  };

  const getTransactions = async (page?: number) => {
    try {
      const res = await requestService.get("/profile/transactions", {
        params: {
          transaction_type: "withdrawal",
          page,
        },
      });
      if (res && res.data) {
        setHistory({
          ...res?.data?.data,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (user) getTransactions();
  }, [user]);

  const handlePostWithDraw = async () => {
    setLoading(true);
    try {
      const res = await requestService.post("/profile/withdrawal", {
        data: {
          amount,
          from: addressTo,
          network: netWorkSelected,
          to: fromTo,
          withdrawPassword,
          fiat_amount: +(
            amount * parseFloat(appGlobal?.[region]?.value)
          )?.toFixed(1),
          payment_type: typeDeposit,
          code: region,
        },
      });
      if (res && res.data) {
        notification.success({
          message: "Deposit success!!!",
          duration: 5,
        });

        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }
    } catch (error: any) {
      notification.error({
        message: "Sila cuba lagi",
        duration: 5,
      });
      console.log(error);
    }
    setLoading(false);
  };

  return (
    <div className="main-box lay-box clearfix">
      <Spin spinning={loading} fullscreen />

      <Modal
        open={isNetWorks}
        footer={null}
        centered
        width={600}
        onCancel={() => setIsNetwork(false)}
      >
        <div className="px-[16px] flex flex-col gap-2">
          {networks.map((n: any, index: number) => (
            <div
              onClick={() => {
                setNetworkSelected(n?.network);
                setIsNetwork(false);
              }}
              key={index}
              className="item flex flex-col p-4 hover:bg-[#1F2023] cursor-auto border border-[#aaa] rounded-xl"
            >
              <div className="text-[#fff] font-[700] mb-2 text-[16px]">
                {n?.network}
              </div>
              <div className="text-[12px] text-[#aaa] mb-1">{n?.code}</div>
              {/* <div className="text-[12px] text-[#aaa] mb-1">
                {n?.account_name}
              </div> */}
            </div>
          ))}
        </div>
      </Modal>
      <Modal
        open={openWithdrawPass}
        footer={null}
        centered
        width={400}
        onCancel={() => setOpenWithdrawPass(false)}
      >
        <div className="text-center text-[18px] text-[#fff] mb-4">
          {t("Nhập mật khẩu rút tiền")}
        </div>
        <div className="bit-select mt-20px w-full box-border phone:mt-8px bit-select--large mb-5">
          <div className="bit-input bit-input--large bit-input--round  bit-input--suffix">
            <input
              type="text"
              autoComplete="off"
              placeholder={t("Nhập mật khẩu rút tiền")}
              className="bit-input__inner"
              value={withdrawPassword}
              onChange={(e) => setWithdrawPassword(e.target.value)}
              style={{ height: 38 }}
            />
          </div>
        </div>{" "}
        <button
          type="button"
          className="bit-button w-full bit-button--chunky bit-button--medium is-round font-[700] mt-[10px]"
          style={{ boxShadow: "0 4px 0 0 undefined" }}
          data-v-489927de=""
          data-testid="LoginNowButton"
          onClick={() => {
            setOpenWithdrawPass(false);
            handlePostWithDraw();
          }}
        >
          {/**/}
          {/**/}
          {/**/}
          <span>{t("Xác nhận")}</span>
          {/**/}
        </button>
      </Modal>
      <Modal
        open={isOpenConfirm}
        footer={null}
        centered
        width={400}
        onCancel={() => setIsOpenConfirm(false)}
      >
        <div className="flex flex-col gap-2 py-2">
          <div className="flex justify-center gap-1 items-center mb-5">
            <img
              src={`https://s2.coinmarketcap.com/static/img/coins/64x64/825.png`}
              width={25}
              className="rounded-full"
              alt=""
            />
            <span className="text-[#ccc] font-[700]">{"USDT"}</span>
            <span className="text-[#aaa] text-[10px] ">
              <Tag className=" uppercase text-[#aaa] text-[12px] min-h-[20px] flex justify-center items-center rounded-md">
                {typeDeposit}
              </Tag>
            </span>
          </div>
          <div className=" p-5 rounded-xl">
            {typeDeposit === "crypto" && (
              <div className="flex items-center justify-between mb-4">
                <div className="text-[#777] text-[14px] mb-2">
                  {t("Mạng lưới")}
                </div>
                <div className="text-[16px] font-[700] text-[#fff] mb-5">
                  {netWorkSelected}
                </div>
              </div>
            )}
            {typeDeposit === "bank" && (
              <div className="flex items-center justify-between mb-4">
                <div className="text-[#777] text-[14px] mb-2">
                  {t("Tên Ngân Hàng")}
                </div>
                <div className="text-[16px] font-[700] text-[#fff] mb-5">
                  {netWorkSelected}
                </div>
              </div>
            )}
            <div className="flex items-center justify-between mb-4">
              <div className="text-[#777] text-[14px] mb-2 flex items-center">
                {typeDeposit === "crypto"
                  ? t("Địa chỉ rút")
                  : t("Số tài khoản")}{" "}
              </div>
              <div className="text-[16px] font-[700] text-[#fff] mb-5">
                {addressTo}
              </div>
            </div>
            {typeDeposit === "bank" && (
              <div className="flex items-center justify-between mb-4">
                <div className="text-[#777] text-[14px] mb-2 flex items-center">
                  {t("Tên người rút")}{" "}
                </div>
                <div className="text-[16px] font-[700] text-[#fff] mb-5">
                  {fromTo}
                </div>
              </div>
            )}

            <div className="flex items-center justify-between mb-4">
              <div className="text-[#777] text-[14px] mb-2">Symbol</div>
              <div className="text-[16px] font-[700] text-[#fff] mb-5">
                {"USDT"}
              </div>
            </div>
            <div className="flex items-center justify-between mb-4">
              <div className="text-[#777] text-[14px] mb-2">
                {t("Số lượng rút")}
              </div>
              <div className="text-[16px] font-[700] text-[#fff] ">
                {amount}
              </div>
            </div>
          </div>
          <button
            type="button"
            className="bit-button w-full bit-button--chunky bit-button--medium is-round font-[700] mt-[10px]"
            style={{ boxShadow: "0 4px 0 0 undefined" }}
            data-v-489927de=""
            data-testid="LoginNowButton"
            onClick={() => {
              if (user?.withdrawPassWord) {
                setOpenWithdrawPass(true);
                setIsOpenConfirm(false);
                return;
              }
              setIsOpenConfirm(false);
              handlePostWithDraw();
            }}
          >
            {/**/}
            {/**/}
            {/**/}
            <span>{t("Xác nhận")}</span>
            {/**/}
          </button>
        </div>
      </Modal>
      <div className="w-full bg-bg">
        <div className="w-1200px py-24px mx-auto box-border air:w-full air:px-24px pad:w-full pad:px-24px phone:w-full phone:px-16px">
          <div className="flex flex-col">
            <div className="mb-[20px] pad:mb-16px phone:mb-16px" />{" "}
            <div className="flex justify-between items-center">
              <span className="text-32px pad:text-20px phone:text-20px font-semibold text-primaryText">
                {t("Rút")}
              </span>{" "}
            </div>
          </div>{" "}
          <div className="flex justify-between mt-32px min-h-396px air:flex-col air:justify-start pad:flex-col pad:justify-start pad:min-h-0 phone:flex-col phone:justify-start phone:min-h-0">
            <div className="w-680px border border-solid border-v3StrengthBorder0 rounded-16px air:w-full pad:w-full phone:w-full !phone:border-0">
              {" "}
              <div className="p-32px phone:p-0">
                <div id="recharge-guide-1">
                  <div className="flex mb-5 gap-3 items-center text-[#fff] font-[700]">
                    <div>Balance:</div>
                    <div className="flex gap-1 items-center">
                      {formatNumber(user?.real_balance || 0)}
                      <img
                        src={`https://s2.coinmarketcap.com/static/img/coins/64x64/825.png`}
                        width={25}
                        className="rounded-full"
                        alt=""
                      />
                    </div>
                  </div>
                  <div id="recharge-guide-1 mt-4">
                    <div>
                      <div className="flex justify-between items-center">
                        <div className="flex items-center gap-1">
                          <div className="w-24px h-24px flex justify-center items-center rounded-12px bg-v3PrimaryText text-v3InverseIcon font-semibold phone:hidden">
                            1
                          </div>{" "}
                          <div className="ml-12px text-fs20 font-semibold text-primaryText phone:ml-0 phone:text-fs16">
                            {t("Chọn loại rút")}
                          </div>
                        </div>{" "}
                      </div>{" "}
                      <div className="pl-9 phone:pl-0 virtualSelect__wrapper hasData">
                        <div className="bit-select mt-20px w-full box-border phone:mt-8px bit-select--large">
                          {/**/}
                          <div className="bit-input bit-input--large bit-input--round  bit-input--suffix relative">
                            {/**/}
                            {/**/}
                            <div className="bit-select mt-20px w-full box-border phone:mt-8px bit-select--large">
                              {/**/}
                              <div className="bit-input bit-input--large bit-input--round !flex  bit-input--suffix">
                                <Tag
                                  onClick={() => {
                                    setTypeDeposit("bank");
                                    setNetworkSelected(null);
                                  }}
                                  color={
                                    typeDeposit === "bank"
                                      ? "volcano-inverse"
                                      : ""
                                  }
                                  className="min-h-[40px] cursor-pointer px-3 flex items-center justify-center"
                                >
                                  {t("Rút tiền ngân hàng")}
                                </Tag>
                                <Tag
                                  onClick={() => {
                                    setTypeDeposit("crypto");
                                    setNetworkSelected(null);
                                  }}
                                  color={
                                    typeDeposit === "crypto"
                                      ? "volcano-inverse"
                                      : ""
                                  }
                                  className="min-h-[40px] cursor-pointer px-3 flex items-center justify-center"
                                >
                                  {t("Rút tiền mã hoá")}
                                </Tag>
                              </div>

                              {/**/}
                            </div>{" "}
                            {/**/}
                            <span className="bit-input__suffix">
                              <span className="bit-input__suffix-inner"></span>
                              {/**/}
                            </span>
                          </div>

                          {/**/}
                        </div>
                      </div>
                    </div>{" "}
                    {typeDeposit === "crypto" && (
                      <div>
                        <div className="flex justify-between items-center mt-40px phone:mt-32px">
                          <div className="flex items-center gap-1">
                            <div className="w-24px h-24px flex justify-center items-center rounded-12px bg-v3PrimaryText text-v3InverseIcon font-semibold phone:hidden">
                              2
                            </div>{" "}
                            <div className="ml-12px text-fs20 font-semibold text-primaryText phone:ml-0 phone:text-fs16">
                              {t("Chọn một mạng")}
                            </div>
                          </div>{" "}
                        </div>{" "}
                        <div className="pl-9 phone:pl-0">
                          <div className="bit-select mt-20px w-full box-border phone:mt-8px bit-select--large">
                            {/**/}
                            <div className="bit-input bit-input--large bit-input--round  bit-input--suffix">
                              {/**/}
                              {/**/}
                              <input
                                type="text"
                                readOnly
                                value={netWorkSelected?.network}
                                autoComplete="off"
                                placeholder={t("Chọn một mạng")}
                                data-testid="RechargeChainSelect"
                                className="bit-input__inner"
                                onClick={() => setIsNetwork(true)}
                                style={{ height: 48 }}
                              />
                              {/**/}
                              <span className="bit-input__suffix">
                                <span className="bit-input__suffix-inner">
                                  <i
                                    className="bit-icon bit-input__icon is-reverse"
                                    style={{ fontSize: 16 }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 24 24"
                                      fill="currentColor"
                                      aria-hidden="true"
                                    >
                                      <path d="M20.03 9.53l-7.5 7.5a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 15.44l6.97-6.97a.75.75 0 011.06 1.06z" />
                                    </svg>
                                  </i>
                                  {/**/}
                                  {/**/}
                                  {/**/}
                                  {/**/}
                                  {/**/}
                                  {/**/}
                                </span>
                                {/**/}
                              </span>
                              {/**/}
                              {/**/}
                              {/**/}
                              {/**/}
                            </div>

                            {/**/}
                          </div>{" "}
                          {/**/}
                        </div>
                      </div>
                    )}
                    {typeDeposit === "bank" && (
                      <>
                        <div>
                          <div className="flex justify-between items-center mt-40px phone:mt-32px">
                            <div className="flex items-center gap-1">
                              <div className="w-24px h-24px flex justify-center items-center rounded-12px bg-v3PrimaryText text-v3InverseIcon font-semibold phone:hidden">
                                2
                              </div>{" "}
                              <div className="ml-12px text-fs20 font-semibold text-primaryText phone:ml-0 phone:text-fs16">
                                {t("Chọn quốc gia nạp")}
                              </div>
                            </div>{" "}
                          </div>{" "}
                          <div className="pl-9 phone:pl-0">
                            <div className="bit-select mt-20px w-full box-border phone:mt-8px bit-select--large">
                              {/**/}
                              <div className="bit-input bit-input--large bit-input--round  bit-input--suffix">
                                {/* <div className="flex flex-wrap gap-2 items-center ">
                                  <Tag
                                    onClick={() => {
                                      setRegion("vi");
                                      setNetworkSelected(null);
                                    }}
                                    color={
                                      region === "vi" ? "volcano-inverse" : ""
                                    }
                                    className="min-h-[40px] cursor-pointer px-3 flex items-center justify-center"
                                  >
                                    Việt Nam
                                  </Tag>
                                  <Tag
                                    onClick={() => {
                                      setNetworkSelected(null);
                                      setRegion("cn");
                                    }}
                                    color={
                                      region === "cn" ? "volcano-inverse" : ""
                                    }
                                    className="min-h-[40px] cursor-pointer px-3 flex items-center justify-center"
                                  >
                                    China
                                  </Tag>
                                  <Tag
                                    onClick={() => {
                                      setNetworkSelected(null);
                                      setRegion("thai");
                                    }}
                                    color={
                                      region === "thai" ? "volcano-inverse" : ""
                                    }
                                    className="min-h-[40px] cursor-pointer px-3 flex items-center justify-center"
                                  >
                                    Thai Land
                                  </Tag>
                                  <Tag
                                    onClick={() => {
                                      setNetworkSelected(null);
                                      setRegion("cam");
                                    }}
                                    color={
                                      region === "cam" ? "volcano-inverse" : ""
                                    }
                                    className="min-h-[40px] cursor-pointer px-3 flex items-center justify-center"
                                  >
                                    Campudia
                                  </Tag>
                                </div> */}
                                <Select
                                  className="bit-input__inner active:shadow-none
                                hover:shadow-none focus:shadow-none
                                text-[#fff]
                                "
                                  onChange={(vl) => {
                                    setRegion(vl);
                                    setNetworkSelected(null);
                                  }}
                                >
                                  <Option value="ms">Malaysia</Option>
                                  <Option value="vi">Việt Nam</Option>
                                  <Option value="cn">China</Option>
                                  <Option value="thai">Thái Lan</Option>
                                  <Option value="cam">Campuchia</Option>
                                  <Option value="en">England</Option>
                                  <Option value="ja">Nhật Bản</Option>
                                  <Option value="sin">Singapore</Option>
                                  <Option value="kor">Hàn Quốc</Option>
                                </Select>
                              </div>

                              {/**/}
                            </div>{" "}
                            {/**/}
                          </div>
                        </div>
                        <div>
                          <div className="flex justify-between items-center mt-40px phone:mt-32px">
                            <div className="flex items-center gap-1">
                              <div className="w-24px h-24px flex justify-center items-center rounded-12px bg-v3PrimaryText text-v3InverseIcon font-semibold phone:hidden">
                                3
                              </div>{" "}
                              <div className="ml-12px text-fs20 font-semibold text-primaryText phone:ml-0 phone:text-fs16">
                                {t("Nhập tên ngân hàng")}
                              </div>
                            </div>{" "}
                          </div>{" "}
                          <div className="pl-9 phone:pl-0">
                            <div className="bit-select mt-20px w-full box-border phone:mt-8px bit-select--large">
                              {/**/}
                              <div className="bit-input bit-input--large bit-input--round  bit-input--suffix">
                                {/**/}
                                {/**/}
                                <input
                                  type="text"
                                  value={netWorkSelected}
                                  onChange={(e) =>
                                    setNetworkSelected(e.target.value)
                                  }
                                  autoComplete="off"
                                  placeholder={t("Chọn một mạng")}
                                  data-testid="RechargeChainSelect"
                                  className="bit-input__inner"
                                  style={{ height: 48 }}
                                />
                                {/**/}
                              </div>

                              {/**/}
                            </div>{" "}
                            {/**/}
                          </div>
                        </div>
                      </>
                    )}
                  </div>{" "}
                  <div>
                    <div className="flex justify-between items-center mt-40px phone:mt-32px">
                      <div className="flex items-center gap-1">
                        <div className="w-24px h-24px flex justify-center items-center rounded-12px bg-v3PrimaryText text-v3InverseIcon font-semibold phone:hidden">
                          {typeDeposit === "bank" ? 4 : 3}
                        </div>{" "}
                        <div className="ml-12px text-fs20 font-semibold text-primaryText phone:ml-0 phone:text-fs16">
                          {t("Nhập số lượng rút")}
                        </div>
                      </div>{" "}
                    </div>{" "}
                    <div className="pl-9 phone:pl-0">
                      <div className="bit-select mt-20px w-full box-border phone:mt-8px bit-select--large">
                        {/**/}
                        <div className="bit-input bit-input--large bit-input--round  bit-input--suffix">
                          {/**/}
                          {/**/}
                          <input
                            type="text"
                            autoComplete="off"
                            placeholder="Nhập số lượng"
                            value={amount}
                            onChange={onChangeMoneyValue}
                            className="bit-input__inner"
                            style={{ height: 48 }}
                          />
                          {typeDeposit === "bank" && (
                            <div className="pl-9 phone:pl-0">
                              <div className="bit-select mt-20px w-full box-border phone:mt-8px bit-select--large">
                                {/**/}
                                <div className="bit-input bit-input--large bit-input--round  bit-input--suffix text-white">
                                  ={" "}
                                  {formatNumber(
                                    +(
                                      amount *
                                      parseFloat(appGlobal?.[region]?.value)
                                    )?.toFixed(1)
                                  )}{" "}
                                  {getCurrencyName(region)}
                                </div>

                                {/**/}
                              </div>{" "}
                              {/**/}
                            </div>
                          )}

                          {/**/}

                          {/**/}
                          {/**/}
                          {/**/}
                          {/**/}
                        </div>

                        {/**/}
                      </div>{" "}
                      {/**/}
                    </div>
                  </div>
                  <div>
                    <div className="flex justify-between items-center mt-40px phone:mt-32px">
                      <div className="flex items-center gap-1">
                        <div className="w-24px h-24px flex justify-center items-center rounded-12px bg-v3PrimaryText text-v3InverseIcon font-semibold phone:hidden">
                          {typeDeposit === "bank" ? 5 : 4}
                        </div>{" "}
                        <div className="ml-12px text-fs20 font-semibold text-primaryText phone:ml-0 phone:text-fs16">
                          {typeDeposit === "bank"
                            ? t("Nhập Số Tài Khoản Nhận")
                            : t("Nhập địa chỉ nhận")}
                        </div>
                      </div>{" "}
                    </div>{" "}
                    <div className="pl-9 phone:pl-0">
                      <div className="bit-select mt-20px w-full box-border phone:mt-8px bit-select--large">
                        {/**/}
                        <div className="bit-input bit-input--large bit-input--round  bit-input--suffix">
                          {/**/}
                          {/**/}
                          <input
                            type="text"
                            autoComplete="off"
                            placeholder="012346789"
                            value={addressTo}
                            onChange={(e) => setAddressTo(e.target.value)}
                            className="bit-input__inner"
                            style={{ height: 48 }}
                          />
                          {/**/}

                          {/**/}
                          {/**/}
                          {/**/}
                          {/**/}
                        </div>

                        {/**/}
                      </div>{" "}
                      {/**/}
                    </div>
                  </div>
                  {typeDeposit === "bank" && (
                    <div>
                      <div className="flex justify-between items-center mt-40px phone:mt-32px">
                        <div className="flex items-center gap-1">
                          <div className="w-24px h-24px flex justify-center items-center rounded-12px bg-v3PrimaryText text-v3InverseIcon font-semibold phone:hidden">
                            6
                          </div>{" "}
                          <div className="ml-12px text-fs20 font-semibold text-primaryText phone:ml-0 phone:text-fs16">
                            {t("Nhập tên người nhận")}
                          </div>
                        </div>{" "}
                      </div>{" "}
                      <div className="pl-9 phone:pl-0">
                        <div className="bit-select mt-20px w-full box-border phone:mt-8px bit-select--large">
                          {/**/}
                          <div className="bit-input bit-input--large bit-input--round  bit-input--suffix">
                            {/**/}
                            {/**/}
                            <input
                              type="text"
                              autoComplete="off"
                              placeholder="Nguyen Văn A"
                              value={fromTo}
                              onChange={(e) => setFromTo(e.target.value)}
                              className="bit-input__inner"
                              style={{ height: 48 }}
                            />
                            {/**/}

                            {/**/}
                            {/**/}
                            {/**/}
                            {/**/}
                          </div>

                          {/**/}
                        </div>{" "}
                        {/**/}
                      </div>
                      {/* <div className="text-[#fff] my-3">
                        Phí rút 3%
                      </div> */}
                    </div>
                  )}
                  <div></div>
                  <div>
                    <div className="flex justify-between items-center mt-40px phone:mt-32px w-full">
                      <div className="flex items-center w-full">
                        <button
                          type="button"
                          className="bit-button w-full bit-button--chunky bit-button--medium is-round font-[700]"
                          style={{ boxShadow: "0 4px 0 0 undefined" }}
                          data-v-489927de=""
                          data-testid="LoginNowButton"
                          onClick={() => {
                            if (amount > user?.real_balance)
                              return notification.error({
                                message: "Không đủ tiền rút",
                                duration: 3,
                              });
                            setIsOpenConfirm(true);
                          }}
                        >
                          {/**/}
                          {/**/}
                          {/**/}
                          <span>{t("Rút")}</span>
                          {/**/}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>{" "}
                {/**/} {/**/}
              </div>
            </div>{" "}
            <div className="w-432px air:w-full air:mt-32px pad:w-full pad:mt-32px phone:w-full phone:mt-32px">
              <div className="px-24px py-24px bg-v3levelsurface1 rounded-16px">
                <div className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M16.5001 21.75C16.5001 21.9489 16.4211 22.1396 16.2805 22.2803C16.1398 22.4209 15.949 22.5 15.7501 22.5H8.25012C8.05121 22.5 7.86045 22.4209 7.71979 22.2803C7.57914 22.1396 7.50012 21.9489 7.50012 21.75C7.50012 21.551 7.57914 21.3603 7.71979 21.2196C7.86045 21.079 8.05121 21 8.25012 21H15.7501C15.949 21 16.1398 21.079 16.2805 21.2196C16.4211 21.3603 16.5001 21.551 16.5001 21.75ZM20.2501 9.74995C20.2534 11.0002 19.9709 12.2347 19.4243 13.3592C18.8778 14.4837 18.0815 15.4685 17.0964 16.2384C16.9122 16.3796 16.7627 16.561 16.6593 16.7688C16.556 16.9767 16.5015 17.2054 16.5001 17.4375V18C16.5001 18.3978 16.3421 18.7793 16.0608 19.0606C15.7795 19.3419 15.3979 19.5 15.0001 19.5H9.00012C8.6023 19.5 8.22077 19.3419 7.93946 19.0606C7.65816 18.7793 7.50012 18.3978 7.50012 18V17.4375C7.49997 17.2081 7.44724 16.9819 7.34599 16.7762C7.24474 16.5704 7.09766 16.3906 6.91606 16.2506C5.93337 15.4852 5.13767 14.5064 4.58916 13.3881C4.04066 12.2698 3.75374 11.0414 3.75012 9.79589C3.72575 5.32777 7.337 1.60683 11.8014 1.49995C12.9014 1.47345 13.9956 1.66725 15.0196 2.06997C16.0436 2.47269 16.9767 3.07617 17.7639 3.84491C18.5512 4.61365 19.1767 5.53211 19.6037 6.54622C20.0306 7.56034 20.2504 8.64962 20.2501 9.74995ZM15.5307 9.96933C15.4611 9.8996 15.3784 9.84428 15.2873 9.80653C15.1963 9.76879 15.0987 9.74936 15.0001 9.74936C14.9016 9.74936 14.804 9.76879 14.7129 9.80653C14.6219 9.84428 14.5392 9.8996 14.4695 9.96933L12.0001 12.4396L9.53075 9.96933C9.39002 9.8286 9.19915 9.74954 9.00012 9.74954C8.8011 9.74954 8.61023 9.8286 8.4695 9.96933C8.32877 10.1101 8.24971 10.3009 8.24971 10.5C8.24971 10.699 8.32877 10.8898 8.4695 11.0306L11.2501 13.8103V17.25C11.2501 17.4489 11.3291 17.6396 11.4698 17.7803C11.6104 17.9209 11.8012 18 12.0001 18C12.199 18 12.3898 17.9209 12.5305 17.7803C12.6711 17.6396 12.7501 17.4489 12.7501 17.25V13.8103L15.5307 11.0306C15.6005 10.9609 15.6558 10.8782 15.6935 10.7872C15.7313 10.6961 15.7507 10.5985 15.7507 10.5C15.7507 10.4014 15.7313 10.3038 15.6935 10.2127C15.6558 10.1217 15.6005 10.039 15.5307 9.96933Z"
                      fill="var(--content-secondary)"
                    />
                  </svg>{" "}
                  <span className="ml-8px text-20px leading-26px font-semibold text-v3PrimaryText">
                    {t("Mẹo")}
                  </span>
                </div>{" "}
                <div className="mt-16px text-v3SecondaryText">
                  <div className="mb-12px last:mb-0 leading-18px">
                    {t(
                      "Không nạp các tài sản khác ngoài USDT, làm như vậy có thể dẫn đến việc không thể khôi phục tài sản đã nạp."
                    )}
                  </div>{" "}
                  <div className="mb-12px last:mb-0 leading-18px">
                    {t(
                      "Tiền nạp dưới số tiền tối thiểu sẽ không được ghi nhận và hoàn trả."
                    )}
                  </div>{" "}
                  <div className="mb-12px last:mb-0 leading-18px">
                    {t(
                      "Đảm bảo thiết bị của bạn an toàn để tránh việc thông tin bị xâm phạm hoặc rò rỉ."
                    )}
                  </div>
                </div>
              </div>{" "}
              <div
                data-v-6fc296c0=""
                className="mt-20px py-32px border-1px border-solid border-v3StrengthBorder0 rounded-16px"
              >
                <div
                  data-v-6fc296c0=""
                  className="px-24px flex items-center justify-between"
                >
                  <span
                    data-v-6fc296c0=""
                    className="text-20px leading-26px font-semibold text-v3PrimaryText"
                  >
                    {t("Câu Hỏi Thường Gặp")}
                  </span>{" "}
                  <div
                    data-v-6fc296c0=""
                    className="flex items-center cursor-pointer"
                  >
                    <span
                      data-v-6fc296c0=""
                      className="mr-4px leading-16px text-12px text-v3TertiaryText"
                    >
                      {t("Thêm")}
                    </span>{" "}
                    <svg
                      data-v-6fc296c0=""
                      xmlns="http://www.w3.org/2000/svg"
                      width={12}
                      height={12}
                      viewBox="0 0 12 12"
                      fill="none"
                      className="rtl-rotate"
                    >
                      <path
                        data-v-6fc296c0=""
                        d="M8.51552 6.26552L4.76552 10.0155C4.73068 10.0504 4.68932 10.078 4.64379 10.0969C4.59827 10.1157 4.54948 10.1254 4.50021 10.1254C4.45094 10.1254 4.40214 10.1157 4.35662 10.0969C4.3111 10.078 4.26974 10.0504 4.2349 10.0155C4.20005 9.98068 4.17242 9.93932 4.15356 9.8938C4.1347 9.84827 4.125 9.79948 4.125 9.75021C4.125 9.70094 4.1347 9.65215 4.15356 9.60662C4.17242 9.5611 4.20005 9.51974 4.2349 9.4849L7.72005 6.00021L4.2349 2.51552C4.16453 2.44516 4.125 2.34972 4.125 2.25021C4.125 2.1507 4.16453 2.05526 4.2349 1.9849C4.30526 1.91453 4.4007 1.875 4.50021 1.875C4.59972 1.875 4.69516 1.91453 4.76552 1.9849L8.51552 5.7349C8.55039 5.76972 8.57805 5.81108 8.59692 5.85661C8.61579 5.90213 8.6255 5.95093 8.6255 6.00021C8.6255 6.04949 8.61579 6.09829 8.59692 6.14381C8.57805 6.18934 8.55039 6.23069 8.51552 6.26552Z"
                        fill="var(--content-tertiary)"
                      />
                    </svg>
                  </div>
                </div>{" "}
                <div
                  data-v-6fc296c0=""
                  className="px-16px mt-16px text-v3SecondaryText"
                >
                  <div
                    data-v-6fc296c0=""
                    className="faq-item flex items-center py-14px px-8px hover:bg-v3BgSecondary hover:rounded-8px text-14px font-medium leading-20px cursor-pointer"
                    onClick={() => setShowGuide(!showGuide)}
                  >
                    <svg
                      data-v-6fc296c0=""
                      xmlns="http://www.w3.org/2000/svg"
                      width={16}
                      height={16}
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        data-v-6fc296c0=""
                        d="M13.3537 5.14625L9.85375 1.64625C9.80728 1.59983 9.75212 1.56303 9.69142 1.53793C9.63073 1.51284 9.56568 1.49995 9.5 1.5H3.5C3.23478 1.5 2.98043 1.60536 2.79289 1.79289C2.60536 1.98043 2.5 2.23478 2.5 2.5V13.5C2.5 13.7652 2.60536 14.0196 2.79289 14.2071C2.98043 14.3946 3.23478 14.5 3.5 14.5H12.5C12.7652 14.5 13.0196 14.3946 13.2071 14.2071C13.3946 14.0196 13.5 13.7652 13.5 13.5V5.5C13.5001 5.43432 13.4872 5.36927 13.4621 5.30857C13.437 5.24788 13.4002 5.19272 13.3537 5.14625ZM10 3.20687L11.7931 5H10V3.20687ZM12.5 13.5H3.5V2.5H9V5.5C9 5.63261 9.05268 5.75978 9.14645 5.85355C9.24021 5.94732 9.36739 6 9.5 6H12.5V13.5ZM10.5 8.5C10.5 8.63261 10.4473 8.75978 10.3536 8.85355C10.2598 8.94732 10.1326 9 10 9H6C5.86739 9 5.74021 8.94732 5.64645 8.85355C5.55268 8.75978 5.5 8.63261 5.5 8.5C5.5 8.36739 5.55268 8.24021 5.64645 8.14645C5.74021 8.05268 5.86739 8 6 8H10C10.1326 8 10.2598 8.05268 10.3536 8.14645C10.4473 8.24021 10.5 8.36739 10.5 8.5ZM10.5 10.5C10.5 10.6326 10.4473 10.7598 10.3536 10.8536C10.2598 10.9473 10.1326 11 10 11H6C5.86739 11 5.74021 10.9473 5.64645 10.8536C5.55268 10.7598 5.5 10.6326 5.5 10.5C5.5 10.3674 5.55268 10.2402 5.64645 10.1464C5.74021 10.0527 5.86739 10 6 10H10C10.1326 10 10.2598 10.0527 10.3536 10.1464C10.4473 10.2402 10.5 10.3674 10.5 10.5Z"
                        fill="var(--content-primary)"
                      />
                    </svg>{" "}
                    <div></div>
                    <span data-v-6fc296c0="" className="ml-8px flex-1 pr-18px">
                      {t("Các biện pháp xử lý khi nạp tiền sai?")}
                    </span>{" "}
                    <div
                      data-v-6fc296c0=""
                      className="faq-icon flex flex-shrink-0"
                    >
                      {showGuide ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          className="size-4"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="m19.5 8.25-7.5 7.5-7.5-7.5"
                          />
                        </svg>
                      ) : (
                        <svg
                          data-v-6fc296c0=""
                          xmlns="http://www.w3.org/2000/svg"
                          width={16}
                          height={16}
                          viewBox="0 0 16 16"
                          fill="none"
                          className="rtl-rotate"
                        >
                          <path
                            data-v-6fc296c0=""
                            d="M11.354 8.35403L6.35403 13.354C6.30757 13.4005 6.25242 13.4373 6.19173 13.4625C6.13103 13.4876 6.06598 13.5006 6.00028 13.5006C5.93458 13.5006 5.86953 13.4876 5.80883 13.4625C5.74813 13.4373 5.69298 13.4005 5.64653 13.354C5.60007 13.3076 5.56322 13.2524 5.53808 13.1917C5.51294 13.131 5.5 13.066 5.5 13.0003C5.5 12.9346 5.51294 12.8695 5.53808 12.8088C5.56322 12.7481 5.60007 12.693 5.64653 12.6465L10.2934 8.00028L5.64653 3.35403C5.55271 3.26021 5.5 3.13296 5.5 3.00028C5.5 2.8676 5.55271 2.74035 5.64653 2.64653C5.74035 2.55271 5.8676 2.5 6.00028 2.5C6.13296 2.5 6.26021 2.55271 6.35403 2.64653L11.354 7.64653C11.4005 7.69296 11.4374 7.74811 11.4626 7.80881C11.4877 7.86951 11.5007 7.93457 11.5007 8.00028C11.5007 8.06599 11.4877 8.13105 11.4626 8.19175C11.4374 8.25245 11.4005 8.30759 11.354 8.35403Z"
                            fill="var(--content-secondary)"
                          />
                        </svg>
                      )}
                    </div>
                  </div>
                  {showGuide && (
                    <div className="px-4">
                      <p className="text-[14px] leading-[20px]">
                        {t("deposit_guide1")}
                        <br />
                        {t("deposit_guide2")}
                      </p>
                    </div>
                  )}

                  <div
                    data-v-6fc296c0=""
                    className="faq-item flex items-center py-14px px-8px hover:bg-v3BgSecondary hover:rounded-8px text-14px font-medium leading-20px cursor-pointer"
                    onClick={() => setShowGuide1(!showGuide1)}
                  >
                    <svg
                      data-v-6fc296c0=""
                      xmlns="http://www.w3.org/2000/svg"
                      width={16}
                      height={16}
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        data-v-6fc296c0=""
                        d="M13.3537 5.14625L9.85375 1.64625C9.80728 1.59983 9.75212 1.56303 9.69142 1.53793C9.63073 1.51284 9.56568 1.49995 9.5 1.5H3.5C3.23478 1.5 2.98043 1.60536 2.79289 1.79289C2.60536 1.98043 2.5 2.23478 2.5 2.5V13.5C2.5 13.7652 2.60536 14.0196 2.79289 14.2071C2.98043 14.3946 3.23478 14.5 3.5 14.5H12.5C12.7652 14.5 13.0196 14.3946 13.2071 14.2071C13.3946 14.0196 13.5 13.7652 13.5 13.5V5.5C13.5001 5.43432 13.4872 5.36927 13.4621 5.30857C13.437 5.24788 13.4002 5.19272 13.3537 5.14625ZM10 3.20687L11.7931 5H10V3.20687ZM12.5 13.5H3.5V2.5H9V5.5C9 5.63261 9.05268 5.75978 9.14645 5.85355C9.24021 5.94732 9.36739 6 9.5 6H12.5V13.5ZM10.5 8.5C10.5 8.63261 10.4473 8.75978 10.3536 8.85355C10.2598 8.94732 10.1326 9 10 9H6C5.86739 9 5.74021 8.94732 5.64645 8.85355C5.55268 8.75978 5.5 8.63261 5.5 8.5C5.5 8.36739 5.55268 8.24021 5.64645 8.14645C5.74021 8.05268 5.86739 8 6 8H10C10.1326 8 10.2598 8.05268 10.3536 8.14645C10.4473 8.24021 10.5 8.36739 10.5 8.5ZM10.5 10.5C10.5 10.6326 10.4473 10.7598 10.3536 10.8536C10.2598 10.9473 10.1326 11 10 11H6C5.86739 11 5.74021 10.9473 5.64645 10.8536C5.55268 10.7598 5.5 10.6326 5.5 10.5C5.5 10.3674 5.55268 10.2402 5.64645 10.1464C5.74021 10.0527 5.86739 10 6 10H10C10.1326 10 10.2598 10.0527 10.3536 10.1464C10.4473 10.2402 10.5 10.3674 10.5 10.5Z"
                        fill="var(--content-primary)"
                      />
                    </svg>{" "}
                    <span data-v-6fc296c0="" className="ml-8px flex-1 pr-18px">
                      {t("Khắc phục sự cố tiền nạp không được ghi nhận")}
                    </span>{" "}
                    <div
                      data-v-6fc296c0=""
                      className="faq-icon flex flex-shrink-0"
                    >
                      {showGuide1 ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          className="size-4"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="m19.5 8.25-7.5 7.5-7.5-7.5"
                          />
                        </svg>
                      ) : (
                        <svg
                          data-v-6fc296c0=""
                          xmlns="http://www.w3.org/2000/svg"
                          width={16}
                          height={16}
                          viewBox="0 0 16 16"
                          fill="none"
                          className="rtl-rotate"
                        >
                          <path
                            data-v-6fc296c0=""
                            d="M11.354 8.35403L6.35403 13.354C6.30757 13.4005 6.25242 13.4373 6.19173 13.4625C6.13103 13.4876 6.06598 13.5006 6.00028 13.5006C5.93458 13.5006 5.86953 13.4876 5.80883 13.4625C5.74813 13.4373 5.69298 13.4005 5.64653 13.354C5.60007 13.3076 5.56322 13.2524 5.53808 13.1917C5.51294 13.131 5.5 13.066 5.5 13.0003C5.5 12.9346 5.51294 12.8695 5.53808 12.8088C5.56322 12.7481 5.60007 12.693 5.64653 12.6465L10.2934 8.00028L5.64653 3.35403C5.55271 3.26021 5.5 3.13296 5.5 3.00028C5.5 2.8676 5.55271 2.74035 5.64653 2.64653C5.74035 2.55271 5.8676 2.5 6.00028 2.5C6.13296 2.5 6.26021 2.55271 6.35403 2.64653L11.354 7.64653C11.4005 7.69296 11.4374 7.74811 11.4626 7.80881C11.4877 7.86951 11.5007 7.93457 11.5007 8.00028C11.5007 8.06599 11.4877 8.13105 11.4626 8.19175C11.4374 8.25245 11.4005 8.30759 11.354 8.35403Z"
                            fill="var(--content-secondary)"
                          />
                        </svg>
                      )}
                    </div>
                  </div>
                  {showGuide1 && (
                    <div className="px-4 ">
                      <p className="text-[14px] leading-[20px]">
                        {t("deposit_guide3")}
                        <br />
                        {t("deposit_guide4")}

                        <br />
                        {t("deposit_guide5")}

                        <br />
                        {t("deposit_guide6")}
                      </p>
                    </div>
                  )}
                  <div
                    data-v-6fc296c0=""
                    className="faq-item flex items-center py-14px px-8px hover:bg-v3BgSecondary hover:rounded-8px text-14px font-medium leading-20px cursor-pointer"
                    onClick={() => setShowGuide2(!showGuide2)}
                  >
                    <svg
                      data-v-6fc296c0=""
                      xmlns="http://www.w3.org/2000/svg"
                      width={16}
                      height={16}
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        data-v-6fc296c0=""
                        d="M13.3537 5.14625L9.85375 1.64625C9.80728 1.59983 9.75212 1.56303 9.69142 1.53793C9.63073 1.51284 9.56568 1.49995 9.5 1.5H3.5C3.23478 1.5 2.98043 1.60536 2.79289 1.79289C2.60536 1.98043 2.5 2.23478 2.5 2.5V13.5C2.5 13.7652 2.60536 14.0196 2.79289 14.2071C2.98043 14.3946 3.23478 14.5 3.5 14.5H12.5C12.7652 14.5 13.0196 14.3946 13.2071 14.2071C13.3946 14.0196 13.5 13.7652 13.5 13.5V5.5C13.5001 5.43432 13.4872 5.36927 13.4621 5.30857C13.437 5.24788 13.4002 5.19272 13.3537 5.14625ZM10 3.20687L11.7931 5H10V3.20687ZM12.5 13.5H3.5V2.5H9V5.5C9 5.63261 9.05268 5.75978 9.14645 5.85355C9.24021 5.94732 9.36739 6 9.5 6H12.5V13.5ZM10.5 8.5C10.5 8.63261 10.4473 8.75978 10.3536 8.85355C10.2598 8.94732 10.1326 9 10 9H6C5.86739 9 5.74021 8.94732 5.64645 8.85355C5.55268 8.75978 5.5 8.63261 5.5 8.5C5.5 8.36739 5.55268 8.24021 5.64645 8.14645C5.74021 8.05268 5.86739 8 6 8H10C10.1326 8 10.2598 8.05268 10.3536 8.14645C10.4473 8.24021 10.5 8.36739 10.5 8.5ZM10.5 10.5C10.5 10.6326 10.4473 10.7598 10.3536 10.8536C10.2598 10.9473 10.1326 11 10 11H6C5.86739 11 5.74021 10.9473 5.64645 10.8536C5.55268 10.7598 5.5 10.6326 5.5 10.5C5.5 10.3674 5.55268 10.2402 5.64645 10.1464C5.74021 10.0527 5.86739 10 6 10H10C10.1326 10 10.2598 10.0527 10.3536 10.1464C10.4473 10.2402 10.5 10.3674 10.5 10.5Z"
                        fill="var(--content-primary)"
                      />
                    </svg>{" "}
                    <span data-v-6fc296c0="" className="ml-8px flex-1 pr-18px">
                      {t("Làm sao để nạp crypto vào tài khoản Sising của bạn")}?
                    </span>{" "}
                    <div
                      data-v-6fc296c0=""
                      className="faq-icon flex flex-shrink-0"
                    >
                      {showGuide2 ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          className="size-4"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="m19.5 8.25-7.5 7.5-7.5-7.5"
                          />
                        </svg>
                      ) : (
                        <svg
                          data-v-6fc296c0=""
                          xmlns="http://www.w3.org/2000/svg"
                          width={16}
                          height={16}
                          viewBox="0 0 16 16"
                          fill="none"
                          className="rtl-rotate"
                        >
                          <path
                            data-v-6fc296c0=""
                            d="M11.354 8.35403L6.35403 13.354C6.30757 13.4005 6.25242 13.4373 6.19173 13.4625C6.13103 13.4876 6.06598 13.5006 6.00028 13.5006C5.93458 13.5006 5.86953 13.4876 5.80883 13.4625C5.74813 13.4373 5.69298 13.4005 5.64653 13.354C5.60007 13.3076 5.56322 13.2524 5.53808 13.1917C5.51294 13.131 5.5 13.066 5.5 13.0003C5.5 12.9346 5.51294 12.8695 5.53808 12.8088C5.56322 12.7481 5.60007 12.693 5.64653 12.6465L10.2934 8.00028L5.64653 3.35403C5.55271 3.26021 5.5 3.13296 5.5 3.00028C5.5 2.8676 5.55271 2.74035 5.64653 2.64653C5.74035 2.55271 5.8676 2.5 6.00028 2.5C6.13296 2.5 6.26021 2.55271 6.35403 2.64653L11.354 7.64653C11.4005 7.69296 11.4374 7.74811 11.4626 7.80881C11.4877 7.86951 11.5007 7.93457 11.5007 8.00028C11.5007 8.06599 11.4877 8.13105 11.4626 8.19175C11.4374 8.25245 11.4005 8.30759 11.354 8.35403Z"
                            fill="var(--content-secondary)"
                          />
                        </svg>
                      )}
                    </div>
                  </div>
                  {showGuide2 && (
                    <div className="px-4">
                      <div className="text-[14px] leading-[20px]">
                        {t("deposit_guide7")}
                        <br />
                        <p>
                          {t("1. Chọn đúng mạng được cho phép nạp vào Sising.")}
                        </p>
                        <p>
                          {t(
                            "2. Đọc kỹ lưu ý tại phần nạp tiền, xem hướng dẫn nạp."
                          )}
                        </p>
                        <p>
                          {t(
                            "3. Việc quét mã chuyển tiền sẽ thuận lợi cho việc chuyển tiề"
                          )}
                        </p>
                        <p>
                          {t(
                            "4. Việc coppy địa chỉ ví và dán ví cần kiểm tra kỹ trước khi nhấn lệnh nạp."
                          )}
                        </p>
                        <p>
                          {t(
                            "Khi hoàn tất việc nạp tiền, kiểm tra lịch sử và đợi lệnh duyệt."
                          )}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>{" "}
              {/**/}
            </div>
          </div>{" "}
          <div data-v-365a5978="" id="record" className="pt-64px">
            <div
              data-v-365a5978=""
              className="flex flex-wrap gap-8px items-center justify-between"
            >
              <span
                data-v-365a5978=""
                className="text-32px font-semibold leading-42px phone:text-20px phone:leading-26px text-v3PrimaryText"
              >
                {t("Lịch sử rút")}
              </span>{" "}
              <div data-v-365a5978="" className="relative">
                <div className="w-auto flex flex-row flex-wrap items-center gap-4px">
                  <div className="whitespace-nowrap text-v3PrimaryText">
                    {t("Tiền rút chưa được ghi nhận?")}{" "}
                  </div>{" "}
                  <a
                    href="#"
                    target="_blank"
                    className="text-[var(--content-link-default)] bit-link bit-link--primary"
                    rel="noreferrer"
                  >
                    {/**/}
                    <span className="bit-link--inner">
                      <div className="flex flex-row items-center">
                        <div>{t("Yêu cầu hoàn tiền")}</div>{" "}
                        <i className="bit-icon" style={{ fontSize: 12 }}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            aria-hidden="true"
                            className="w-12px h-12px rtl-rotate"
                          >
                            <path d="M17.03 12.53l-7.5 7.5a.75.75 0 11-1.06-1.06L15.44 12 8.47 5.03a.75.75 0 111.06-1.06l7.5 7.5a.75.75 0 010 1.06z" />
                          </svg>
                        </i>
                      </div>
                    </span>
                    {/**/}
                  </a>
                </div>
              </div>
            </div>{" "}
            <div className="relative overflow-x-auto hidden sm:block mt-4">
              <table className="w-full ">
                <thead className="">
                  <tr className="text-[#8e8e92] font-[500]">
                    <th scope="col" className="px-6 py-3">
                      {t("Lệnh")}
                    </th>
                    <th scope="col" className="px-6 py-3">
                      {t("Số lượng")}
                    </th>

                    <th scope="col" className="px-6 py-3 ">
                      {t("Mạng rút")}
                    </th>
                    <th scope="col" className="px-6 py-3 ">
                      {t("Trạng thái")}
                    </th>
                    <th scope="col" className="px-6 py-3  md:block ">
                      {t("Thời gian")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {!!historyData?.transations?.length &&
                    historyData?.transations?.map((i: any, index: number) => (
                      <tr
                        className=" border-[#9999]  text-[#fff] font-[500] cursor-pointer"
                        key={i?.id}
                      >
                        <td className="px-6 py-4 font-medium ">{i?._id}</td>
                        <td className="px-6 py-4 font-medium flex items-center gap-1 ">
                          {i?.value}
                          <img
                            src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${i.token_id}.png`}
                            width={20}
                            alt=""
                            className="rounded-full"
                          />
                        </td>
                        <td className="px-6 py-4">{i?.network}</td>
                        <td className="px-6 py-4">
                          {i?.transaction_status === "pending" && (
                            <Tag color="warning">Pending</Tag>
                          )}
                          {i?.transaction_status === "finish" && (
                            <Tag color="green-inverse">Success</Tag>
                          )}
                          {i?.transaction_status === "cancel" && (
                            <Tag color="red-inverse">Cancel</Tag>
                          )}
                        </td>
                        <td className="px-6 py-4">
                          {new Date(i?.createdAt)?.toLocaleString()}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="flex flex-col gap-3  sm:hidden mt-4">
              {!!historyData?.transations?.length &&
                historyData?.transations?.map((i: any, index: number) => (
                  <div className="flex flex-col gap-2">
                    <div className="flex justify-between items-center">
                      <div className="flex items-center gap-1 text-[#ccc]">
                        {t("Rút")}
                        <img
                          src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${i.token_id}.png`}
                          width={20}
                          alt=""
                          className="rounded-full"
                        />
                      </div>
                      <div>
                        {i?.transaction_status === "pending" && (
                          <Tag>Pending</Tag>
                        )}
                        {i?.transaction_status === "finish" && (
                          <Tag>Success</Tag>
                        )}
                        {i?.transaction_status === "cancel" && (
                          <Tag>Cancel</Tag>
                        )}
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div className="text-[#aaa] text-[10px]">
                        {t("Số lượng")}
                      </div>
                      <div className="text-[#aaa] text-[10px]">{i?.value}</div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div className="text-[#aaa] text-[10px]">{t("Mạng")}</div>
                      <div className="text-[#aaa] text-[10px]">
                        {i?.network}
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div className="text-[#aaa] text-[10px]">{t("Lệnh")}</div>
                      <div className="text-[#aaa] text-[10px]">{i?._id}</div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div className="text-[#aaa] text-[10px]">
                        {t("Thời gian")}
                      </div>
                      <div className="text-[#aaa] text-[10px]">
                        {new Date(i?.createdAt)?.toLocaleString()}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            <Pagination
              defaultCurrent={1}
              total={historyData?.total}
              showSizeChanger={false}
              onChange={onChangePage}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Withdraw;
